export default __webpack_public_path__ + "static/media/dark-graph-icon.013a5c9f.svg";